<template>
  <div class="routerContent">
    <!-- 搜索区域 -->
    <el-row class="search-row" type="flex" justify="start" align="top">
      <el-col :span="24">
        <div class="card df p10">
          <el-form
            :model="searchForm"
            label-width="100px"
            label-position="right"
            ref="searchForm"
            size="mini"
            :inline="true"
          >
            <el-form-item label="项目编号">
              <el-input
                v-model="searchForm.xmCode"
                placeholder="请输入项目编号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input
                v-model="searchForm.xmName"
                placeholder="请输入项目名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="项目经理">
              <el-input
                v-model="searchForm.xmPmName"
                placeholder="请输入项目经理姓名"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="部门名称">
              <el-input
                v-model="searchForm.organName"
                placeholder="请输入部门名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getData('refresh')">查询</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <!-- 主要内容区域：左右分栏 -->
    <div class="main-content">
      <div class="flex" style="height: 100%">
        <!-- 左侧：未选择的项目 -->
        <div class="left-panel df fdc w14 fg1 ova">
          <h4>项目列表:</h4>
          <el-table
            :data="availableProjects"
            @selection-change="handleAvailableSelectionChange"
            height="100%"
            border
            size="small"
            ref="availableTable"
          >
            <el-table-column type="selection" fixed="left" align="center"></el-table-column>
            <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
            <el-table-column
              prop="xmCode"
              label="项目编号"
              align="left"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="xmName"
              label="项目名称"
              align="left"
              min-width="150"
            ></el-table-column>
            <el-table-column
              prop="xmPmName"
              label="项目经理"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="organName"
              label="部门名称"
              align="center"
              min-width="120"
            ></el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="card ova" style="text-align: center; padding: 10px 0">
            <el-pagination
              @size-change="sizeChange"
              @current-change="currentChange"
              :current-page="pager.page"
              :page-size="pager.size"
              background
              layout="total, sizes, prev, pager, next"
              :total="pager.total"
            ></el-pagination>
          </div>
        </div>

        <!-- 中间：操作按钮 -->
        <div class="btnbox">
          <div>
            <el-button
              type="primary"
              icon="el-icon-d-arrow-right"
              @click="moveToSelected"
              :disabled="!availableCheckedData.length"
              >选择</el-button
            >
            <br />
            <el-button
              type="primary"
              icon="el-icon-d-arrow-left"
              @click="moveToAvailable"
              :disabled="!selectedCheckedData.length"
              >移除</el-button
            >
          </div>
        </div>

        <!-- 右侧：已选择的项目 -->
        <div class="right-panel df fdc w14 fg1 ova">
          <h4>已选择项目:</h4>
          <el-table
            :data="selectedProjects"
            @selection-change="handleSelectedSelectionChange"
            border
            height="100%"
            size="small"
            ref="selectedTable"
            style="width: 100%"
          >
            <el-table-column type="selection" fixed="left" align="center"></el-table-column>
            <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
            <el-table-column
              prop="xmCode"
              label="项目编号"
              align="left"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="xmName"
              label="项目名称"
              align="left"
              min-width="150"
            ></el-table-column>
            <el-table-column
              prop="xmPmName"
              label="项目经理"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="organName"
              label="部门名称"
              align="center"
              min-width="120"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="footer-bar">
      <div class="buttons-container">
        <el-button type="primary" :disabled="!selectedProjects.length" @click="confirmSelection"
          >确定</el-button
        >
        <el-button @click="cancelSelection">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XmList',
  props: {
    allowMultiple: {
      type: Boolean,
      default: true
    },
    allowedXmIds: {
      type: Array,
      default: () => []
    },
    onlyFromAllowed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchForm: {
        xmCode: '',
        xmName: '',
        xmPmName: '',
        organName: ''
      },
      pager: {
        size: 20,
        total: 0,
        page: 1
      },
      dataList: [], // 原始数据列表
      availableProjects: [], // 左侧可选择的项目列表
      selectedProjects: [], // 右侧已选择的项目列表
      availableCheckedData: [], // 左侧选中的项目
      selectedCheckedData: [], // 右侧选中的项目
      // 保持向后兼容
      selectedRows: [], // 兼容旧的接口
      selectedRowIds: [] // 兼容旧的接口
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 设置已选择的项目
    setSelectedProjects(projects) {
      this.selectedProjects = [...projects];
      this.selectedRows = [...projects]; // 保持向后兼容
      this.selectedRowIds = projects.map((item) => item.xmId);

      // 更新可选择的项目列表（排除已选择的）
      this.updateAvailableProjects();
    },
    // 更新可选择的项目列表
    updateAvailableProjects() {
      const selectedIds = this.selectedProjects.map((item) => item.xmId);
      this.availableProjects = this.dataList.filter((item) => !selectedIds.includes(item.xmId));
    },

    // 左侧表格选择变化事件
    handleAvailableSelectionChange(selection) {
      this.availableCheckedData = selection;
    },

    // 右侧表格选择变化事件
    handleSelectedSelectionChange(selection) {
      this.selectedCheckedData = selection;
    },

    // 将选中的项目移动到已选择列表
    moveToSelected() {
      if (this.availableCheckedData.length === 0) {
        this.$message.warning('请先选择要添加的项目');
        return;
      }

      // 如果不允许多选，检查限制
      if (!this.allowMultiple) {
        if (this.availableCheckedData.length > 1 || this.selectedProjects.length > 0) {
          this.$message.warning('只能选择一个项目！');
          return;
        }
      }

      // 添加到已选择列表
      this.availableCheckedData.forEach((item) => {
        if (!this.selectedProjects.some((selected) => selected.xmId === item.xmId)) {
          this.selectedProjects.push(item);
        }
      });

      // 从可选择列表中移除
      this.availableProjects = this.availableProjects.filter((item) => {
        return !this.availableCheckedData.some((checked) => checked.xmId === item.xmId);
      });

      // 清空选择
      this.availableCheckedData = [];
      this.$refs.availableTable.clearSelection();

      // 更新兼容数据
      this.updateCompatibilityData();
    },

    // 将选中的项目移动到可选择列表
    moveToAvailable() {
      if (this.selectedCheckedData.length === 0) {
        this.$message.warning('请先选择要移除的项目');
        return;
      }

      // 添加到可选择列表
      this.selectedCheckedData.forEach((item) => {
        if (!this.availableProjects.some((available) => available.xmId === item.xmId)) {
          this.availableProjects.unshift(item);
        }
      });

      // 从已选择列表中移除
      this.selectedProjects = this.selectedProjects.filter((item) => {
        return !this.selectedCheckedData.some((checked) => checked.xmId === item.xmId);
      });

      // 清空选择
      this.selectedCheckedData = [];
      this.$refs.selectedTable.clearSelection();

      // 更新兼容数据
      this.updateCompatibilityData();
    },

    // 更新兼容性数据
    updateCompatibilityData() {
      this.selectedRows = [...this.selectedProjects];
      this.selectedRowIds = this.selectedProjects.map((item) => item.xmId);
    },

    // 分页大小变化
    sizeChange(size) {
      this.pager.size = size;
      this.getData('refresh');
    },

    // 当前页变化
    currentChange(page) {
      this.pager.page = page;
      this.getData();
    },
    confirmSelection() {
      // 通过自定义事件将选中的项目数据传递给父组件
      if (this.selectedProjects.length > 0) {
        this.$emit('confirm', this.selectedProjects);
      } else {
        this.$message.warning('请先选择项目');
      }
    },
    cancelSelection() {
      // 触发取消事件
      this.$emit('cancel');
    },
    getData(type) {
      if (type === 'refresh') {
        this.pager.page = 1;
      }

      const params = {
        pageNum: this.pager.page,
        pageSize: this.pager.size,
        xmCode: this.searchForm.xmCode,
        xmName: this.searchForm.xmName,
        xmPmName: this.searchForm.xmPmName,
        organName: this.searchForm.organName
      };

      // 如果只能从允许的项目中选择，则添加过滤条件
      if (this.onlyFromAllowed && this.allowedXmIds.length > 0) {
        // 过滤掉null值的ID
        const validXmIds = this.allowedXmIds.filter(
          (id) => id !== null && typeof id !== 'undefined'
        );
        if (validXmIds.length > 0) {
          params.allowedXmIds = validXmIds.join(',');
        }
      }

      const load = this.$loading({
        target: this.$refs.availableTable?.$el || document.body
      });

      this.$api
        .formPost('/api/major/xmgl/doGetList', params)
        .then((res) => {
          if (res.retHead && res.retHead.code === '0000000') {
            load.close();
            this.dataList = res.retBody.list || [];
            this.pager.total = res.retBody.total || 0;

            // 如果只能从允许的项目中选择，过滤数据列表
            if (this.onlyFromAllowed && this.allowedXmIds.length > 0) {
              // 过滤掉null值的ID，并进行客户端过滤
              const validXmIds = this.allowedXmIds.filter(
                (id) => id !== null && typeof id !== 'undefined'
              );
              if (validXmIds.length > 0) {
                this.dataList = this.dataList.filter((item) => validXmIds.includes(item.xmId));
              }
            }

            // 更新可选择的项目列表（排除已选择的）
            this.updateAvailableProjects();
          } else {
            load.close();
          }
        })
        .catch(() => {
          load.close();
        });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        xmCode: '',
        xmName: '',
        xmPmName: '',
        organName: ''
      };
      // 重置所有选择状态
      this.selectedProjects = [];
      this.availableCheckedData = [];
      this.selectedCheckedData = [];
      this.selectedRows = []; // 保持向后兼容
      this.selectedRowIds = []; // 保持向后兼容
      this.getData('refresh');
    }
  }
};
</script>

<style lang="scss" scoped>
.routerContent {
  display: flex;
  flex-direction: column;
  height: 65vh;
  border: 1px solid #f1f1f1;
  overflow: hidden;
}

.search-row {
  flex-shrink: 0;
}

.card {
  margin-bottom: 0;
  padding: 10px;
  background: #fff;
  border-radius: 4px;
}

.main-content {
  flex: 1;
  overflow: hidden;
  padding: 10px;
  background: #fff;
}

.flex {
  display: flex;
}

.left-panel,
.right-panel {
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
  padding: 10px;
  margin: 0 5px;
}

.left-panel {
  margin-left: 0;
}

.right-panel {
  margin-right: 0;
}

.btnbox {
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;

  button {
    margin-bottom: 10px;
    width: 80px;
  }
}

.footer-bar {
  flex-shrink: 0;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 20px;
  border-top: 1px solid #f0f0f0;
}

.buttons-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.df {
  display: flex;
}

.fdc {
  flex-direction: column;
}

.ova {
  overflow: auto;
}

.fg1 {
  flex: 1;
}

.w14 {
  width: 100%;
}

.pcth100 {
  height: 100%;
}

h4 {
  margin: 0 0 10px 0;
  padding: 0;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

/* 移除表格行悬停效果 */
:deep(.el-table__row:hover > td) {
  background-color: transparent !important;
}

:deep(.el-table__row.current-row > td) {
  background-color: transparent !important;
}

/* 调整表格样式 */
:deep(.el-table) {
  font-size: 12px;
}

:deep(.el-table th) {
  background-color: #f5f7fa;
  font-weight: bold;
}

/* 分页样式调整 */
:deep(.el-pagination) {
  text-align: center;
}

:deep(.el-pagination .btn-prev, .el-pagination .btn-next, .el-pagination .el-pager li) {
  min-width: 28px;
  height: 28px;
  line-height: 28px;
}
</style>
